import { PublicLayout } from "@/layouts/PublicLayout";

export default function Terms() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-2xl px-4 py-12 space-y-8 text-foreground">
        <h1 className="text-3xl font-bold">Bruksvilkår</h1>
        <p className="text-muted-foreground">Sist oppdatert: 22. februar 2026</p>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">1. Om tjenesten</h2>
          <p>
            Flyt er en familieapp utviklet og levert av Inwent AS, org.nr. 834 661 012.
            Tjenesten hjelper foreldre med å organisere barnas hverdag gjennom gjøremål,
            samværskalender og skjermtidsstyring.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">2. Brukerens ansvar</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Du er ansvarlig for å holde innloggingsopplysningene dine konfidensielle.</li>
            <li>Du er ansvarlig for innholdet du legger inn i tjenesten.</li>
            <li>Tjenesten skal ikke brukes til ulovlige formål.</li>
          </ul>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">3. Abonnement og betaling</h2>
          <p>
            Flyt tilbyr en gratis plan med begrenset funksjonalitet, samt betalte
            planer (Plus og Sammen). Betalte planer faktureres månedlig eller årlig
            via Stripe. Du kan når som helst endre eller avslutte abonnementet ditt.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">4. Oppsigelse og sletting</h2>
          <p>
            Du kan når som helst slette kontoen din. Ved sletting fjernes alle dine
            personopplysninger og familiedata permanent. Kontakt oss på{" "}
            <a href="mailto:hei@inwent.no" className="text-primary underline">hei@inwent.no</a>{" "}
            dersom du ønsker hjelp med sletting.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">5. Tilgjengelighet</h2>
          <p>
            Vi tilstreber høy oppetid, men kan ikke garantere uavbrutt tilgang.
            Tjenesten leveres «som den er» uten garantier utover det som følger av
            ufravikelig lovgivning.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">6. Ansvarsbegrensning</h2>
          <p>
            Inwent AS er ikke ansvarlig for indirekte tap, følgeskader eller tap av
            data utover det som følger av ufravikelig norsk lov.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">7. Endringer i vilkårene</h2>
          <p>
            Vi kan endre disse vilkårene. Vesentlige endringer varsles i appen eller
            per e-post med rimelig varsel.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">8. Lovvalg og verneting</h2>
          <p>
            Disse vilkårene er underlagt norsk lov. Eventuelle tvister skal søkes
            løst i minnelighet. Dersom dette ikke fører frem, avgjøres tvisten ved
            Oslo tingrett.
          </p>
        </section>
      </div>
    </PublicLayout>
  );
}
